import React, { useState } from 'react'

// Partials
import Btn from 'views/shared/partials/btn'
import { InputForm, FormInput } from 'views/shared/partials/forms'

// Deps
//import { closeModal } from 'utils/modals'
// import parse from 'html-react-parser'
// import extend from 'lodash/extend'
// import omit from 'lodash/omit'

// Services
import orderServices from 'services/order'

// Assets

const AdminNoteModal = ({ orderID, note, closeBtn, close, className, onSuccess }) => {
	const [submitting, setSubmitting] = useState(false);

	const submit = (formData) => {
		setSubmitting(true);

		orderServices.createOrderNote(orderID, formData.note).then(() => {
			if(onSuccess) {
				onSuccess();
			}
			close();
		}).catch((e) => {
			console.warn('Order note creation error: ', e);
		}).finally(() => {
			setSubmitting(false);
		})
	}

	return (
		<div className={className}>
			<div className="modal-header dark">
				<h1 className="modal-title">Yönetici Notu {note ? 'Düzenle' : 'Ekle'}</h1>
				{closeBtn}
			</div>
			<InputForm className="modal-content grid-container" onSubmit={submit}>
				<div className="row">
					<div className="col x12">
						<FormInput
							type="textarea"
							rows="4"
							name="note" 
							label="Notunuz"
							validation={{
								required: 'Bir not girmelisiniz.',
							}} />
					</div>
				</div>
				<div className="row">
					<div className="col x12 al-right">
						<Btn
							wide
							type="submit"
							loading={submitting}
							disabled={submitting}>
							{note ? 'Kaydet' : 'Ekle'}
						</Btn>
					</div>
				</div>
			</InputForm>
		</div>
	)
}

AdminNoteModal.defaultProps = {
	className: "",
	containerClass: "modal-admin-note narrow",
	name: "admin-note",
	note: false,
	orderID: false,
	onSuccess: false,
}

export default AdminNoteModal